import { useState, useEffect, useRef } from 'react';
import { marked } from 'marked';
import './App.css';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [showNavLogo, setShowNavLogo] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeAnnouncement, setActiveAnnouncement] = useState(0);
  const [slideDirection, setSlideDirection] = useState('');
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [announcementContent, setAnnouncementContent] = useState('');
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const announcementRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      
      const announcementsSection = document.getElementById('announcements');
      if (announcementsSection) {
        const rect = announcementsSection.getBoundingClientRect();
        setShowNavLogo(rect.top <= 80);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/announcements/index.json`)
      .then(res => res.json())
      .then(data => setAnnouncements(data))
      .catch(err => console.error('Failed to load announcements:', err));
  }, []);

  useEffect(() => {
    if (showAnnouncementModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showAnnouncementModal]);

  const carouselTexts = [
    '空岛生存大更新将至!',
    '忙里偷闲，享受人生',
    '多种玩法，无限乐趣',
    '加入我们，开启冒险',
    '空岛生存大更新将至!',
  ];

  const gamemodes = [
    {
      icon: 'Eyeofender.png',
      title: '空岛生存',
      quote: '空岛生存的玩法可谓是家喻户晓。在虚空中的小岛上开始你的生存之旅，利用有限的资源发展壮大。',
      desc1: '空岛生存是一款经典的生存小游戏。玩家需利用好岛屿上的资源，在虚空中建立自己的家园。其上手简单，玩法丰富的特点吸引了大量玩家成为空岛生存的忠实爱好者。',
      desc2: '在空岛生存中，你需要合理规划资源，扩展岛屿，挑战各种任务目标，最终建造出属于自己的空中王国。'
    },
    {
      icon: 'Mushroom_stew.png',
      title: '绝剑法则',
      quote: '绝剑法则是一场真正的剑术对决。基于快节奏的PvP玩法，考验你的反应速度和战斗技巧。',
      desc1: '这是一场真正的剑术挑战。快节奏的对战游戏，考验你的反应速度、预判能力以及战斗技巧。',
      desc2: '绝剑法则融合了多种战斗元素，玩家需要掌握攻防节奏，在激烈的对决中成为真正的剑术大师！'
    },
    {
      icon: 'End_stone.png',
      title: '核心战争',
      quote: '核心战争是一款非常经典的游戏。早在2012年它就出现在Shotbow服务器上并成为老一代我的世界玩家热衷的游戏。',
      desc1: '核心战争是一款大型多人在线玩家对战游戏。玩家需要收集资源，加强防御，保护好队伍的核心(末地石)。每场游戏分为五个阶段，每个阶段会有不同的事件发生。',
      desc2: '核心战争的深度是大部分游戏模式无法匹敌的。与你的队友合理分工合作，控制资源，摧毁敌人的核心以取得游戏的胜利！'
    },
    {
      icon: 'Bed.png',
      title: '起床战争',
      quote: '起床战争是目前最火爆的一款小游戏之一。我们推出了单挑、双人及团队等多种模式，满足不同玩家的需求。',
      desc1: '起床战争是一款快节奏的玩家对战小游戏。在游戏中，摧毁敌人的床并击杀他们以取得游戏的胜利。游戏内有多种资源，用这些资源来增强自己，击败你的敌人吧！',
      desc2: '要做好起床战争这款游戏可谓不易，这款游戏需要极致的平衡才能确保游戏的公平。我们进行了多次平衡性修改，确保游戏达到预期的平衡值。'
    },
    {
      icon: 'Goldenapple.png',
      title: '极限生存',
      quote: '极限生存是一场真正的生存挑战。一条命的终极考验，死亡即永久出局。',
      desc1: '这是一场真正的生存挑战。在危机四伏的世界中证明你的生存能力，随机世界、原版PvE、独特的挑战在等着你。',
      desc2: '极限生存考验的不仅是你的游戏技术，更是你的决策能力和风险管理。在这里，每一个选择都可能决定生死！'
    }
  ];

  const teamMembers = [
    { name: 'Xiao_Lins', nickname: '小林', role: '地球天空的创始人、总监督.' },
    { name: 'Sempron', nickname: '闪龙', role: '地球天空的总管理员、运营事务统筹者.' },
    { name: 'Ryuko', nickname: '笔记本', role: '地球天空的总管理员、主策划、主开发.' },
    { name: 'RealJiand', nickname: '煎蛋', role: '地球天空的总管理员、主策划、主开发、监督.' },
    { name: '7Pigpig', nickname: '猪猪', role: '地球天空的日常事务管理员、特色玩法开发者.' },
    { name: 'ChineseDragon', nickname: '拆妮子抓根', role: '地球天空的日常事务管理员、地图建筑总管.' },
    { name: 'MarKerS1', nickname: '麻克斯', role: '地球天空的日常事务管理员、秩序维护总管.' },
    { name: 'Yayoi', nickname: '弥生', role: '地球天空的日常事务管理员.' }
  ];

  const qqGroups = [
    { name: '官方1群', number: '616444639', link: 'https://qm.qq.com/q/juPbcm3eBa' },
    { name: '官方2群', number: '874462523', link: 'https://qm.qq.com/q/MTyzQHvBG6' },
    { name: '官方3群', number: '182670005', link: 'https://qm.qq.com/q/c6lUVm39fO' },
    { name: '官方4群', number: '531581648', link: 'https://qm.qq.com/q/Wpegbnzr0o' },
    { name: '官方5群', number: '339605679', link: 'https://qm.qq.com/q/kIN0OFP6fK' },
    { name: '官方6群', number: '414554298', link: 'https://qm.qq.com/q/v8vGHbQNBm' }
  ];

  const handlePrevAnnouncement = () => {
    setSlideDirection('slide-right');
    setTimeout(() => {
      setActiveAnnouncement(prev => (prev === 0 ? announcements.length - 1 : prev - 1));
      setSlideDirection('');
    }, 150);
  };

  const handleNextAnnouncement = () => {
    setSlideDirection('slide-left');
    setTimeout(() => {
      setActiveAnnouncement(prev => (prev === announcements.length - 1 ? 0 : prev + 1));
      setSlideDirection('');
    }, 150);
  };

  const openAnnouncementModal = async (announcement) => {
    setSelectedAnnouncement(announcement);
    setShowAnnouncementModal(true);
    
    try {
      const res = await fetch(`${process.env.PUBLIC_URL}/announcements/${announcement.file}`);
      const content = await res.text();
      setAnnouncementContent(content);
    } catch (err) {
      console.error('Failed to load announcement content:', err);
      setAnnouncementContent('加载失败，请稍后重试。');
    }
  };

  const closeAnnouncementModal = () => {
    setShowAnnouncementModal(false);
    setSelectedAnnouncement(null);
    setAnnouncementContent('');
  };

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      handleNextAnnouncement();
    } else if (isRightSwipe) {
      handlePrevAnnouncement();
    }
  };

  const renderMarkdown = (content) => {
    if (!content) return '';
    
    marked.setOptions({
      breaks: true,
      gfm: true,
    });
    
    return marked.parse(content);
  };

  if (announcements.length === 0) {
    return <div className="App loading">加载中...</div>;
  }

  return (
    <div className="App">
      {/* Navigation */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <img 
          src={`${process.env.PUBLIC_URL}/assets/logo.png`} 
          alt="地球天空" 
          className={`nav-logo ${showNavLogo ? 'visible' : ''}`}
        />
        <ul className="nav-links">
          <li><a href="#announcements">公告</a></li>
          <li><a href="#gamemodes">玩法</a></li>
          <li><a href="#team">团队</a></li>
          <li><a href="/wiki">百科</a></li>
        </ul>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div 
          className="hero-background" 
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/background.png)` }}
        ></div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <img src={`${process.env.PUBLIC_URL}/assets/big_logo.png`} alt="地球天空" className="big-logo" />
          <h1 className="hero-title">探索永无止境</h1>
          <div className="carousel-container">
            <div className="carousel-text">
              {carouselTexts.map((text, index) => (
                <div key={index} className="carousel-item">{text}</div>
              ))}
            </div>
          </div>
          <a 
            href="https://mc.163.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hero-download-btn"
          >
            点击开玩!
          </a>
        </div>
        <div className="scroll-indicator">
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 5v14M19 12l-7 7-7-7"/>
          </svg>
        </div>
      </section>

      {/* Announcements Section */}
      <section id="announcements" className="section announcements">
        <h2 className="section-title">最新公告</h2>

        <div
          className="announcement-carousel"
          ref={announcementRef}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <button className="carousel-arrow carousel-arrow-left" onClick={handlePrevAnnouncement}>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <div
            className={`announcement-card ${slideDirection}`}
            onClick={() => openAnnouncementModal(announcements[activeAnnouncement])}
          >
            <div className="announcement-header">
              <span className="announcement-tag">{announcements[activeAnnouncement].tag}</span>
              <span className="announcement-date">{announcements[activeAnnouncement].date}</span>
            </div>
            <h3 className="announcement-title">{announcements[activeAnnouncement].title}</h3>
            <p className="announcement-summary">{announcements[activeAnnouncement].summary}</p>
            <span className="announcement-readmore">点击查看详情 →</span>
          </div>

          <button className="carousel-arrow carousel-arrow-right" onClick={handleNextAnnouncement}>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>

        <div className="announcement-dots">
          {announcements.map((_, index) => (
            <button
              key={index}
              className={`announcement-dot ${activeAnnouncement === index ? 'active' : ''}`}
              onClick={() => setActiveAnnouncement(index)}
            />
          ))}
        </div>
      </section>

      {/* Gamemodes Section */}
      <section id="gamemodes" className="section gamemodes">
        <h2 className="section-title">我们从未停止对快乐的探索</h2>

        {/* Tab Navigation */}
        <div className="tabs-nav">
          {gamemodes.map((mode, index) => (
            <button
              key={index}
              className={`tab-btn ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/${mode.icon}`}
                alt={mode.title}
                className="tab-icon-img"
              />
              <span className="tab-title">{mode.title}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          <div className="tab-content-inner">
            <div className="tab-quote">
              <blockquote>
                <p>{gamemodes[activeTab].quote}</p>
                <footer>地球天空 原创出品</footer>
              </blockquote>
            </div>
            <div className="tab-desc">
              <p>{gamemodes[activeTab].desc1}</p>
            </div>
            <div className="tab-desc">
              <p>{gamemodes[activeTab].desc2}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Announcement Modal */}
      {showAnnouncementModal && selectedAnnouncement && (
        <div className="modal-overlay" onClick={closeAnnouncementModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeAnnouncementModal}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
            <div className="modal-header">
              <span className="modal-tag">{selectedAnnouncement.tag}</span>
              <span className="modal-date">{selectedAnnouncement.date}</span>
            </div>
            <h2 className="modal-title">{selectedAnnouncement.title}</h2>
            <div 
              className="modal-body"
              dangerouslySetInnerHTML={{ __html: renderMarkdown(announcementContent) }}
            />
          </div>
        </div>
      )}

      {/* Team Section */}
      <section id="team" className="section team">
        <h2 className="section-title">关于 SkyPixel Dev</h2>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <h3 className="member-name">{member.name} / {member.nickname}</h3>
              <p className="member-role">{member.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo">
            <img src={`${process.env.PUBLIC_URL}/assets/big_logo.png`} alt="地球天空" />
          </div>
          <div className="footer-content">
            <div className="footer-left">
              <p className="footer-slogan">地球天空运营组致力于为您带来快乐！</p>
              <p className="footer-tagline">专业 / 效率 / 温情</p>
            </div>
            <div className="footer-right">
            <h4 className="footer-section-title">玩家社群</h4>
            <div className="footer-groups">
              {qqGroups.map((group, index) => (
                <a 
                  key={index} 
                  href={group.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-group-row"
                >
                  <span className="group-name">地球天空{group.name}：</span>
                  <span className="group-id">{group.number}</span>
                </a>
              ))}
            </div>
          </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span className="footer-copyright">© {new Date().getFullYear()} 地球天空 SkyPixel. All rights reserved.</span>
          <span className="footer-divider">|</span>
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="footer-icp">
            粤ICP备15051067号-1
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
